import { useEffect, useRef, useState } from 'react';
import { PLAYER_COLORS } from '../../engine/simulation/simulation';

export const COLOUR_NAMES = ['Blue', 'Red', 'Yellow', 'Green', 'Purple', 'Teal', 'Orange', 'Pink'];
const hex = (c: number) => '#' + c.toString(16).padStart(6, '0');

/** First player colour not already taken. */
export function freeColour(taken: (number | undefined)[]): number {
  return PLAYER_COLORS.find((c) => !taken.includes(c)) ?? PLAYER_COLORS[0];
}

/** A colour swatch that opens a small palette; colours other players already use are unavailable. */
export function ColourPicker({ value, taken, onChange, disabled }: { value: number; taken: number[]; onChange: (c: number) => void; disabled?: boolean }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  const name = COLOUR_NAMES[PLAYER_COLORS.indexOf(value)] ?? 'Colour';
  return (
    <div className="colour-picker" ref={ref}>
      <button type="button" className="swatch swatch-btn" style={{ background: hex(value) }} disabled={disabled} title={disabled ? name : `${name} (click to change)`} aria-label={`Colour: ${name}`} onClick={() => setOpen(!open)} />
      {open && (
        <div className="colour-pop" role="listbox">
          {PLAYER_COLORS.map((c, i) => {
            const used = c !== value && taken.includes(c);
            return (
              <button type="button" key={c} className={`swatch swatch-btn ${c === value ? 'current' : ''}`} style={{ background: hex(c) }} disabled={used}
                title={used ? `${COLOUR_NAMES[i]} (taken)` : COLOUR_NAMES[i]} aria-label={COLOUR_NAMES[i]} onClick={() => { onChange(c); setOpen(false); }} />
            );
          })}
        </div>
      )}
    </div>
  );
}
